<template>
    <div v-if="confirmShowBox" class="edit-order-approval-text-box">
      <div class="close-icon" @click="confirmHideBox">
        <i class='bx bx-x'></i>
      </div>
      <div class="text-1">
        <p>We have made changes to your {{ editedOrderCount }} order{{ editedOrderCount > 1 ? '(s)' : ''}}.</p>
      </div>
      <div class="btn-box">
        <router-link 
          :to="{ 
            path: '/order-opprovals', 
            query: $route.query 
          }"
          class="btn-1" 
          @click="resendEmail"
        >
          Review Now
        </router-link>
      </div>
   
    </div>
  </template>
  
  <script>
  export default {
    components: {},
    props: ['editedOrderCount'],
    watch: {
      editedOrderCount() {
        if(this.$route.name == "dashboard" && this.editedOrderCount > 0){
          this.confirmShowBox = true;
        }else{
          this.confirmShowBox = false;
        }
      },
    },
    mounted() {},
    data() {
      return {
        confirmShowBox: false,
      };
    },
    methods: {
      confirmHideBox() {
        this.confirmShowBox = false;
      },
      resendEmail() {
        this.confirmShowBox = false;
      },
    },
  };
  </script>
  